import React, { memo } from 'react';
import moment from 'moment';

function SmsPreview({ variation }) {
  return (
    <section className="message-container__preview">
      <div className="pos-relative">
        <div className="preview">
          <div className="preview_sms preview_mobile preview_android">
            <div
              id="sms-android"
              className="preview-inner"
              style={{
                margin: 0,
                height: 618,
              }}
            >
              <div className="preview-device empty"></div>
              <div className="preview-device mobile mobile_android"></div>
              <div className="preview-content">
                <div className="sms-preview-body">
                  <div className="clearfix">
                    <div className="sms-preview-from">8</div>
                    <div
                      className="sms-preview-message"
                      style={{ textAlign: 'left' }}
                    >
                      {variation && variation.message
                        ? variation.message.split('\n').map((item, i) => (
                            <span key={i}>
                              {item}
                              <br />
                            </span>
                          ))
                        : ''}
                    </div>
                  </div>
                  <br />
                  <div className="sms-preview-footer">
                    {moment().format('H:mm') + ' via SMS'}
                  </div>
                </div>
                <div className="sms-preview-msg-textfield">Send an SMS</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const Memoized = memo(SmsPreview);

export { Memoized as SmsPreview };
